
<button mat-flat-button (click)="uploadFileInput.click()" class="upload-button subtle-button-color">
    <i class="mr-2 ms-Icon ms-Icon--Upload" aria-hidden="true"></i>
    <span i18n="my documents upload document button text@@my-documents-upload-document-button-text">Upload to OneDrive</span>
</button>
<label hidden for="input-file-id">Id: </label>
<input hidden type="file" #uploadFileInput (change)="uploadFile($event)" id="input-file-id" name="file" />
